import PlatformWireframe from '@/components/marketing/technology/PlatformWireframe'
import TechnologySubPage from '@/components/marketing/technology/TechnologySubPage'
import type { TechnologySubPageProps } from '@/types/technology'

/* The technology section — the Distribution page.
 *
 * All sub-pages share one layout and differ only in the props
 * TechnologyController builds from TechnologyContent. This file exists because
 * the marketing entrypoint resolves `render inertia: "technology/Platform"`
 * against this exact path — it is the route, not a place for page-specific
 * markup.
 *
 * The visual is a WIREFRAME, not the two full product mocks this page used to
 * carry. Those made it enormously tall before a reader reached a single
 * capability, and they now have pages of their own that the wireframe links
 * into. A wireframe answers the same question — what am I actually getting —
 * in a fraction of the height, and makes no promises about colour or spacing
 * that a screenshot would.
 */
export default function Platform(props: TechnologySubPageProps) {
  return <TechnologySubPage {...props} visual={<PlatformWireframe />} />
}
